import {makeStyles} from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    position: 'sticky',
    zIndex: 1001,
    top: '-21px',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.49) 0%, rgba(255, 255, 255, 0.48) 110.84%)',
    width: '100%',
    height: '71px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.top': {
      background: 'transparent',
      border: 'none'
    },
    '&.top .nav': {
      background: theme.palette.primary.primary100,
      transition: 'background 0.2s ease-in-out',
      borderRadius: '42px',
      filter: 'drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.07))'
    }
  },
  navigation: {
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '591px',
    height: '42px',
    padding: '5px 9px',
  },
  navigationItem: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: theme.palette.primary.primary800,
    padding: '6px 12px',
    height: '32px',
    borderRadius: '30px',
    whiteSpace: 'nowrap',
    '&.selected': {
      background: theme.palette.primary.primary200
    }
  },
  navigationItemText: {
    marginLeft: '5px',
    fontSize: '12px',
    fontWeight: 600
  }
}));

export default useStyles;
